import { render, staticRenderFns } from "./item-type.html?vue&type=template&id=043f3b2a&scoped=true&external"
import script from "./item-type.js?vue&type=script&lang=js&external"
export * from "./item-type.js?vue&type=script&lang=js&external"
import style0 from "./item-type.scss?vue&type=style&index=0&id=043f3b2a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043f3b2a",
  null
  
)

export default component.exports